import { Box } from '@factorialco/deprecated-design-system'
import { TrainingsSessionAttendanceStatusEnum } from 'generated/resources/graphql'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { SessionMembershipStatusTag } from 'modules/trainings/components/Revamp/SessionMembershipStatusTag'
import { useUpdateSessionAttendances } from 'modules/trainings/hooks/SessionAttendance/useUpdateSessionAttendances'

type Props = {
  status: TrainingsSessionAttendanceStatusEnum
  idsAttendance: number[]
}

export const AttendanceButton = ({ status, idsAttendance }: Props) => {
  const { updateSessionAttendances } = useUpdateSessionAttendances()
  const saveAttendance = async () => {
    const result = await updateSessionAttendances({
      ids: idsAttendance,
      status: status,
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t(
          'trainings.trainings_revamp.event_sidepanel.update_attendance_error_message'
        ),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t(
          'trainings.trainings_revamp.event_sidepanel.update_attendance_success_message'
        ),
      })
    }
  }
  return (
    <Box onClick={() => saveAttendance()}>
      <SessionMembershipStatusTag status={status} />
    </Box>
  )
}
